import { renderAccordionHeader_unstable } from '@fluentui/react-accordion';

/**
 * Renders the final JSX of the AccordionHeader component, given the state and context values.
 */
export const renderAccordionHeader = renderAccordionHeader_unstable;
